import { useQuery } from "@tanstack/react-query";
import { useLanguageStore } from "../stores/languageStore.ts";
import { getConfig } from "../services/configService";

export interface Language {
  locale: string;
  displayText: string;
  country: string;
}

export interface LanguageResponse {
  languages: Language[];
}

async function getSupportedLanguages(language: string): Promise<Language[]> {
  const config = await getConfig();
  const url = new URL(`${config.api.baseUrl}/public/languages`);

  const response = await fetch(url.toString(), {
    headers: {
      "Accept-Language": language,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch user data");
  }

  return response.json().then((value: LanguageResponse) => value.languages);
}

export function useSupportedLanguages() {
  const { language } = useLanguageStore();
  return useQuery({
    queryKey: ["supportedLanguages", language],
    queryFn: () => getSupportedLanguages(language),
    staleTime: Infinity,
  });
}
